import React from "react";

export function LoginForm({ 
  t, 
  email, 
  setEmail, 
  pass, 
  setPass, 
  loading, 
  setLoading, 
  onLogin, 
  onForgotPassword, 
  addToast 
}) {
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await onLogin(email, pass);
    } catch (err) {
      addToast(err.message, "error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <div className="form-group">
        <label className="form-label">{t.email}</label>
        <div className="form-input-wrap">
          <span className="form-input-icon">✉</span>
          <input
            className="form-input"
            type="email"
            placeholder={t.emailPlaceholder}
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            disabled={loading}
          />
        </div>
      </div>
      <div className="form-group">
        <label className="form-label">{t.password}</label>
        <div className="form-input-wrap">
          <span className="form-input-icon">🔒</span>
          <input
            className="form-input"
            type="password"
            placeholder={t.passwordPlaceholder}
            value={pass}
            onChange={(e) => setPass(e.target.value)}
            disabled={loading}
          />
        </div>
      </div>
      <button className="btn-primary" type="submit" disabled={loading}>
        {loading ? "…" : t.signInBtn}
      </button>
      <div style={{ textAlign: "center", marginTop: 14 }}>
        <button
          type="button"
          className="link-btn"
          onClick={onForgotPassword}
          style={{ fontSize: 13 }}
        >
          {t.forgotPassword}
        </button>
      </div>
    </form>
  );
}